module.exports = __webpack_public_path__ + "img/10_spit.8d38d48e.png";